import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorNotAnOwner } from "@/shared/connection/with-store-error-handlers";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger("footers.service");

const NDA_ENDPOINT = `/footer-ndas`;

export const ndasService = {
    getAllByFooterUuid(uuid = "") {
        logger.trace("getAllByFooterUuid", uuid);
        return ajaxCall
            .get(`${NDA_ENDPOINT}`, { params: { footerUuid: uuid } })
            .catch(handleErrorNotAnOwner());
    },
    createNda(nda) {
        return ajaxCall.post(NDA_ENDPOINT, nda).catch(handleErrorNotAnOwner());
    },
    updateNda(nda) {
        return ajaxCall.patch(`${NDA_ENDPOINT}/${nda.id}`, nda).catch(handleErrorNotAnOwner());
    },
    deleteNda(nda) {
        return ajaxCall.delete(`${NDA_ENDPOINT}/${nda.id}`).catch(handleErrorNotAnOwner());
    },
};
